import {CONTACT_POOLS_FIELDS} from '@/modules/auditorAudits/contants/auditorAudits';

export const isCoverSection = (section) => (
  !!section?.metadata?.coverFields?.length
);
export const isContactSection = (section) => (
  !!section?.metadata?.contactFields?.length
);

export const isSection = (item) => (
  !!isCoverSection(item) || item?.questions?.length
);

export const filterContactFields = (section, isPoolService) => {
  if (!isPoolService) {
    return section?.metadata?.contactFields?.filter((field) => {
      return !CONTACT_POOLS_FIELDS.includes(field?.type);
    });
  }
  else {
    return section?.metadata?.contactFields;
  }
};

export const extractSectionFields = (section, isPoolService) => {
  if (isContactSection(section)) {
    return [
      filterContactFields(section, isPoolService),
      isContactSection(section)
    ];
  } else {
    return[
      isCoverSection(section) ? section?.metadata?.coverFields : section?.questions,
      isCoverSection(section)
    ];
  }
};

export const getSectionScore = (section) => (
  `${section?.finalScore || 0} / ${section?.totalScore || 0} (${Number(
    (section?.finalScore * 100) / section?.totalScore || 0
  ).toFixed(1)}%)`
);

export const getUnansweredQuestions = (sectionData) => {
  let array = [];
  sectionData?.forEach((section) => {
    section?.questions?.forEach((question) => {
      if (!question?.answer) {
        array.push({ _id: question?._id, title: question?.name, section: section?._id });
      }
    });
  });
  return array;
};

export const getFailedQuestions = (sectionData) => {
  let array = [];
  sectionData?.forEach((section) => {
    section?.questions?.forEach((question) => {
      if (question?.type === 'select' && question?.select?.options) {
        const failedOption = question?.select?.options?.filter((el) => el?.failed);
        let value = question?.answer?.templateAnswer?.select;
        if (!Array.isArray(value)) {
          value = [value];
        }
        if (failedOption?.length && value?.some(el => failedOption?.some(x => x?._id === el))) {
          array.push({ _id: question?._id, title: question?.name, section: section?._id });
        }
      }
    });
  });
  return array;
};

